
import Vue from 'vue'

/**
 * Reject panoramic photos
 */
const rejectPanoramicPhotos = ({ id }) =>
  Vue.$http.post('workplan/reject_panoramic_photos/',  { id })
    .then()
    .catch((err) => {
      throw err
    })

export default rejectPanoramicPhotos



// WEBPACK FOOTER //
// ./src/services/workPlan/rejectPanoramicPhotos.js